export class ProdutosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listProducts(filter) {
    return this.instance.get('/v1/product', {
      params: filter || null,
    });
  }

  showProduct(id) {
    return this.instance.get(`/v1/product/${id}`);
  }

  insertProduct(data) {
    return this.instance.post(`/v1/product/`, data);
  }

  updateProduct(id, data) {
    return this.instance.put(`/v1/product/${id}`, data);
  }

  removeProduct(id) {
    return this.instance.delete(`/v1/product/${id}`);
  }
}

export default ProdutosFactory;
